import React from "react";
import { formatDate, formatWeekRange } from "../../utils/dateUtils";

export default function ViewControls({
  viewType,
  currentDate,
  currentWeekStart,
  handlePrevious,
  handleNext,
  handleToday,
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
      <button
        onClick={handlePrevious}
        style={{
          padding: "4px 8px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: "#ffffff",
          cursor: "pointer",
          fontSize: 18,
          lineHeight: 1,
          minWidth: 32,
        }}
        title="Previous"
      >
        ←
      </button>
      <div style={{ flex: 1, textAlign: "center", fontSize: 15, fontWeight: 600 }}>
        {viewType === "daily" ? formatDate(currentDate) : formatWeekRange(currentWeekStart)}
      </div>
      <button
        onClick={handleNext}
        style={{
          padding: "4px 8px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: "#ffffff",
          cursor: "pointer",
          fontSize: 18,
          lineHeight: 1,
          minWidth: 32,
        }}
        title="Next"
      >
        →
      </button>
      <button
        onClick={handleToday}
        style={{
          padding: "6px 12px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: "#ffffff",
          color: "#323338",
          cursor: "pointer",
          fontSize: 14,
          marginLeft: 8,
        }}
      >
        Today
      </button>
    </div>
  );
}

